import { RejectedStatusView } from "./rejected-status-view.tsx";
import overlayStyles from "../shared/offboarding-page-overlay.module.css";

export interface RejectedStatusModalProps {
    open: boolean;
    approverComment?: string | null;
    loading?: boolean;
    onResign: () => void;
    updatedAt?: string | null;
}

/** Page-scoped rejected status dialog. */
export function RejectedStatusModal({
    open,
    approverComment,
    loading = false,
    onResign,
    updatedAt,
}: RejectedStatusModalProps) {
    if (!open) return null;

    return (
        <div className={overlayStyles.overlay} role="presentation">
            <div
                className={overlayStyles.dialog}
                role="dialog"
                aria-modal="true"
                aria-label="Resignation request rejected"
                onClick={(e) => e.stopPropagation()}
            >
                <RejectedStatusView
                    approverComment={approverComment}
                    loading={loading}
                    onResign={onResign}
                    updatedAt={updatedAt}
                />
            </div>
        </div>
    );
}
